import { useState } from "react";
import { motion } from "motion/react";
import classNames from "classnames";
import { useBjelinTranslations } from "../hooks/TranslationHooks";
import { RoundIconButton } from "./RoundIconButton";

const ExpandableContent = ({
  initialHeight = "10em",
  backgroundColor = "#fff",
  disabled = false,
  children
}) => {
  const t = useBjelinTranslations();
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      style={{
        backgroundColor
      }}
    >
      <motion.div
        className={classNames({ "content-fade": !expanded && !disabled })}
        style={{
          position: "relative",
          inset: 0,
          overflow: "hidden",
          paddingBottom: expanded && !disabled ? "3.8em" : 0,
          backgroundColor
        }}
        animate={{
          height: expanded || disabled ? "auto" : initialHeight
        }}
      >
        {children}
      </motion.div>
      {!disabled && (
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "3em",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <RoundIconButton
            icon={expanded ? "chevron-up" : "chevron-down"}
            onClick={() => setExpanded(exp => !exp)}
            style={{ boxShadow: "1px 1px 5px rgba(0,0,0,0.4)" }}
            title={expanded ? t("action.close") : t("action.show-more")}
          />
        </div>
      )}
    </div>
  );
};

export default ExpandableContent;
